import { PartitionOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import AutomationsCriteriaConditionsWrapper from 'automations/components/Nodes/AutomationsCriteriaConditionsWrapper';
import IfElseNodeAdditionalContent from 'automations/components/Nodes/IfElseNodeAdditionalContent';
import { type IfElseNodeType, nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type ConditionNodeReturnProps } from './useConditionNodeConfig';

export default function useIfElse(node: NodeProps<IfElseNodeType>): ConditionNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.IfElseNodeData, node.data), [node.data]);
  const AdditionalUi = useMemo(() => <IfElseNodeAdditionalContent node={node} />, [node]);

  const subTitle = useMemo(() => {
    if (node.data?.additionalOptions?.criteriaGroupId) {
      return (
        <AutomationsCriteriaConditionsWrapper
          criteriaId={node.data.additionalOptions.criteriaGroupId}
          onCriteriaChange={() => {}}
          builderUi={() => null}
          textOnly
          renderFilters
        />
      );
    } else {
      return null;
    }
  }, [node.data?.additionalOptions?.criteriaGroupId]);

  return {
    subTitle,
    icon: PartitionOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI: AdditionalUi,
  };
}
